"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VersatileContent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="239345" id="finalcta" className="bg-background text-foreground py-32 md:py-40">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-3xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tighter">Pronto para gravar seu podcast profissional?</h2>
        <p className="font-sans text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed">Grave seu podcast em nosso estúdio em Pinheiros com estrutura completa e suporte profissional.</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="rounded-full px-8 text-base h-12 bg-primary hover:bg-primary/90 text-primary-foreground w-full sm:w-auto shadow-lg transition-all">
            <Link to="https://wa.me/5511969100007">Falar no WhatsApp</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="rounded-full px-8 text-base h-12 border-primary text-primary hover:bg-primary/5 w-full sm:w-auto transition-all">
            <Link to="https://itcmais.com/o-estudio/">Ver o estúdio</Link>
          </Button>
        </div>
      </div>
    </section>;
}